/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdRolesQueryResponse,
  GetApiV1PersonIdRolesPathParams,
  GetApiV1PersonIdRoles401,
  GetApiV1PersonIdRoles404,
  GetApiV1PersonIdRoles500,
} from "../../types/personRegisterController/GetApiV1PersonIdRoles.ts";

function getGetApiV1PersonIdRolesUrl(
  id: GetApiV1PersonIdRolesPathParams["id"],
) {
  const res = { method: "GET", url: `/api/v1/person/${id}/roles` as const };
  return res;
}

/**
 * @description Retorna as flags de papéis (student, teaching staff, etc.) da pessoa. **(Requer Authorization para autenticação)**
 * @summary Obter papéis da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/roles}
 */
export async function getApiV1PersonIdRoles(
  id: GetApiV1PersonIdRolesPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdRolesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdRoles401
      | GetApiV1PersonIdRoles404
      | GetApiV1PersonIdRoles500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdRolesUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
